import React, { ComponentProps } from 'react';
import { Form, Input, Row, SonForm, SubmitButton, TextParam, useForm } from '../../../_lib/Form2';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { useRefreshBlock } from '../../../_lib/BlockFetcher';

type CollapsibleContainerEditViewProps = {
  form: SonForm<TextParam<'title'>>;
};

export function CollapsibleContainerEditView({ form }: CollapsibleContainerEditViewProps) {
  const { t } = useSonTranslation('CollapsibleContainerBlock');
  const { delayedRefresh } = useRefreshBlock();

  const { formProps, params, fetchState } = useForm({
    form,
    onSuccess: () => {
      delayedRefresh();
    },
  });

  const titleParam = params.findByName('title');

  return (
    <Form {...formProps}>
      <Row>
        <Input label={t('edit.titleLabel')} param={titleParam} />
      </Row>
      <SubmitButton
        buttonLabel={t('edit.submitButtonLabel')}
        messageSuccess={t('phrases:changeSuccesfull')}
        messageSending={t('phrases:processIsCurrentlyRunningWithDots')}
        messageFail={t('phrases:changesCouldNotBeSaved')}
        fetchState={fetchState}
      />
    </Form>
  );
}

export const CollapsibleContainerBlockEditView = asFetchableView(CollapsibleContainerEditView);
export type CollapsibleContainerBlockEditView = ComponentProps<typeof CollapsibleContainerEditView>;
